module.exports = __webpack_public_path__ + "static/media/gh.a64592b4.svg";